import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import OriginImpcOperatorPredesSenderMismatchReport from '../../components/OriginImpcOperatorPredesSenderMismatchReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/OriginImpcOperatorPredesSenderMismatchDetailsSelectors';

export function OriginImpcOperatorPredesSenderMismatchDetailsContainer(props) {
  return (
    <OriginImpcOperatorPredesSenderMismatchReport
      reportId={ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

OriginImpcOperatorPredesSenderMismatchDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(OriginImpcOperatorPredesSenderMismatchDetailsContainer);
